import { combineReducers } from 'redux';

import createIntegrationApp from './modules/create/createIntegrationApp/reducer';
import welcomeModal from './modules/welcomeModal/reducer';

export default combineReducers({
  createIntegrationApp,
  welcomeModal,
});
